import { camelCaseTransformer } from '@sondermind/utilities/tools';

export class InternalReferralDetails {
  personaProvider: IInternalReferralPersonaProvider;
  referringType: string;
  referringReason: string;
  preferences: string;
  diagnoses: IInternalReferralDiagnoses[];
  referringReferralReasons: string[];

  constructor(json: InternalReferralDetailsResponse) {
    if (json.persona_provider) {
      this.personaProvider = {
        id: json.persona_provider.id,
        fullName: json.persona_provider.full_name || '',
        displayFirstName: json.persona_provider.display_first_name || '',
        displayName: json.persona_provider.display_name || '',
        pronouns: json.persona_provider.pronouns || '',
        initials: json.persona_provider.initials || '',
        phoneNumber: json.persona_provider.phone_number || '',
        credentials: camelCaseTransformer(json.persona_provider.credentials) || []
      };
    }
    this.referringType = json.referring_type;
    this.referringReason = json.referring_reason;
    this.preferences = json.preferences;
    this.diagnoses = json.diagnoses;
    this.referringReferralReasons = json.referring_referral_reasons;
  }
}

export interface IInternalReferralPersonaProvider {
  id: number;
  fullName: string;
  displayFirstName: string;
  displayName: string;
  pronouns: string;
  initials: string;
  phoneNumber: string;
  credentials: Array<{ externalTitle: string; externalTag: string; }>;
}
export interface IInternalReferralDiagnoses {
  reference_data_id: number;
  title: string;
  tag: string;
}

export type InternalReferralDetailsResponse = {
  persona_provider: {
    id: number;
    full_name: string;
    display_first_name: string;
    display_name: string;
    pronouns: string;
    initials: string;
    phone_number: string;
    education_level: string;
    credentials: Array<{ external_title: string; external_tag: string; }>;
  };
  referring_type: string;
  referring_reason: string;
  preferences: string;
  diagnoses: Array<{ reference_data_id: number; title: string; tag: string; }>;
  referring_referral_reasons: string[];
};
